module.exports = "data:application/octet-stream;base64,Ly8gQ29weSB0ZXh0dXJlCi8vIFRoaXMgaXMgYW4gZXh0ZW5zaW9uIG9mIHdlYmxhcy4KLy8gaHR0cHM6Ly9naXRodWIuY29tL3dheWxvbmZsaW5uL3dlYmxhcwoKcHJlY2lzaW9uIGhpZ2hwIGZsb2F0OwoKdmFyeWluZyB2ZWMyIG91dFRleDsKdW5pZm9ybSBzYW1wbGVyMkQgc291cmNlOwoKdm9pZCBtYWluKHZvaWQpIHsKICBnbF9GcmFnQ29sb3IgPSB0ZXh0dXJlMkQoc291cmNlLCB2ZWMyKG91dFRleC54LCBvdXRUZXgueSkpOwp9Cg=="


//////////////////
// WEBPACK FOOTER
// ./~/keras-js/lib/texture_copy.glsl
// module id = OSEp
// module chunks = 1